import { AsyncPipe, NgClass, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { CustomDecimalPipeModule, OnlyNumberDirective } from '@sdvor/shared/ui';
import { IconModule, SpinnerComponent } from '@spartacus/storefront';
import { SdvorItemCounterComponent } from './item-counter.component';

@NgModule({
  imports: [
    NgIf,
    NgClass,
    AsyncPipe,
    ReactiveFormsModule,
    SpinnerComponent,
    OnlyNumberDirective,
    IconModule,
    CustomDecimalPipeModule,
  ],
  declarations: [SdvorItemCounterComponent],
  exports: [SdvorItemCounterComponent],
})
export class SdvorItemCounterModule {}
